<div class="mt-5">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-4 offset-md-4">
        <div class="bg-white shadow rounded-4 p-5">
          <div class="text-center">
            <img src="../../../assets/alt_logo.png" class="w-25 mt-3">
          </div>
          <div>
            <form #loginForm="ngForm">
              <div class="form-group">
                <label class="form-label required">Email Id</label>
                <input type="email" class="form-control" name="emailId" [(ngModel)]="loginObj.email"
                  required>
              </div>
              <div class="form-group mt-4">
                <label class="form-label required" for="password">Password</label>
                <div class="input-group">
                  <input [type]="passwordType" class="form-control" id="password"
                    [(ngModel)]="loginObj.password" name="password" #pswd="ngModel" required />
                  <span class="input-group-text pointer" (click)="onShowPassword()">
                    <i class="bi" [ngClass]="showPassword ? 'bi-eye' : 'bi-eye-slash'"></i>
                  </span>
                </div>
                @if (pswd.invalid && pswd.touched) {
                  <div class="text-danger">
                    Please enter your password
                  </div>
                }
              </div>
              <button type="submit" class="btn btn-primary w-100 mt-4" [disabled]="!loginForm.valid"
                (click)="onLogin(loginForm)">
                LOGIN
              </button>
              <div class="form-group mt-4 text-center">
                <a class="btn btn-outline-primary border-0" [routerLink]="['/forgot-password']">Forgot
                Password</a>
              </div>
              @if (errorMessage) {
                <div class="mt-2">
                  <ngb-alert type="danger" (closed)="errorMessage = '' ">{{ errorMessage }}</ngb-alert>
                </div>
              }
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>